export class TipoValorCreditoFinanceiro {

  id: number;
  descriao: string;

}
